/*
 * @developerName: 邓科峰
 * @Function name:
 * @Date: 2025-12-05 10:12:30
 * @param:
 * @LastEditor:
 * @LastData:
 * @Describe:
 */
import Vue from 'vue'
import Router from 'vue-router'
import basicMap from '@/components/basic-map'
import basicList from '@/components/basic-list'
import basicAdd from '@/components/basic-add'
import person from '@/components/person'
import login from '@/components/login'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'basicMap',
      component: basicMap
    },
    {
      path: '/basic-list',
      name: 'basicList',
      component: basicList
    },
    {
      path: '/basic-add',
      name: 'basicAdd',
      component: basicAdd
    },
    {
      path: '/person',
      name: 'person',
      component: person
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/my-orders',
      component: () => import('@/components/my-orders.vue')
    },
    {
      path: '/create-order',
      component: () => import('@/components/create-order.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js